import React, { forwardRef } from 'react';
import { Editor } from '@hugerte/hugerte-react';

export const HugeRTEWrapper = forwardRef(({ value, onChange, placeholder, height = 250, init: customInit, ...props }, ref) => (
  <Editor
    init={{
      toolbar: 'undo redo | styleselect | forecolor | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | link image | code | bullist',
      height,
      menubar: false,
      statusbar: false,
      plugins: ['lists', 'link'],
      placeholder: placeholder || '',
      outputFormat: 'html',
      // Remove deprecated features
      remove_trailing_brs: true,
      convert_urls: false,
      highlight_on_focus: false,
      ...customInit,
    }}
    value={value}
    onEditorChange={value => onChange?.(value)}
    onKeyDown={event => props.onKeyDown?.(event)}
    ref={ref}
    {...props}
  />
))